/**
 * A click on a button or link inside a clickable row: the control keeps its
 * own action and the row's click is skipped.
 * @param {MouseEvent} event
 */
export const isNestedControlClick = (event) =>
  Boolean(event.target.closest("button, a"));
